import LandingPageV2 from "../layout/landing-v2";
import { withTranslation } from "../i18n";
import { languageParser } from "../helpers/general";
import { getCFCountry, getPaymentCountry } from "../helpers/setCookie";
import {
    fetchLandingPageContent,
    fetchLandingPricing,
} from "../helpers/landingPageSsr";
import { getTokenUser } from "../helpers/cookie";

const NewLandingPage = ({ initialLanguage, cfCountry, landingPageContent, page_source, pricingContent, additionalProps }) => {
    // LandingPageV2's own <Head> emits the full homepage meta set (title,
    // description, og:*, twitter:*, icons, keywords) when useHomepageSeo is
    // set — emitting another copy here produced duplicate og:* tags because
    // Next 9 dedupes `name` metas but not `property` ones.
    return (
        <LandingPageV2 landingPageContent={landingPageContent} initialLanguage={initialLanguage} cfCountry={cfCountry} page_source={page_source} pricingContent={pricingContent} additionalProps={additionalProps} useHomepageSeo />
    );
};

NewLandingPage.getInitialProps = async (ctx) => {
    const currentLanguage = languageParser(ctx);

    const userCountry = getCFCountry(ctx);
    let actualCFCountry = null;

    // Log cf-ipcountry header
    if (ctx.req && ctx.req.headers) {
        actualCFCountry = ctx.req.headers["cf-ipcountry"];
    }

    if (!!userCountry === false && !!actualCFCountry) {
        const finalLanguage = actualCFCountry === "ID" ? 'id' : "en";
        if (currentLanguage !== finalLanguage) {
            ctx.res.redirect(`/lang/${finalLanguage}?redirect=mainpage`);
            return {};
        }
    }

    // Kedua fetch independen — dijalankan paralel supaya TTFB tidak menunggu
    // dua round-trip Laravel berurutan (SSR landing sempat ~7s).
    const country = ctx.query.country
        || getPaymentCountry(ctx)
        || getCFCountry(ctx)
        || "ID";
    const token = getTokenUser(ctx);
    const additionalHeaders = token ? { authorization: token } : {};

    // Root '/' uses page_source 'premium' but is served by THIS file (not
    // pages/new-landing-page), so it must fetch the premium pricingContent too —
    // otherwise layout/landing-v2 getHighestCardLabelPercentage gets no card data,
    // returns null, and the CTA button falls back to the BE highest_percentage
    // scalar (e.g. 93) instead of the highest "Save X%"/"Diskon X%" package card
    // (=40). Mirrors pages/new-landing-page/index.js.
    const [landingPageContent, pricingContent] = await Promise.all([
        fetchLandingPageContent(ctx, {
            page_source: 'premium'
        }).catch(() => ({})),
        fetchLandingPricing(ctx, {
            language: currentLanguage,
            page_source: 'premium',
            country,
        }, additionalHeaders).catch(() => null),
    ]);

    return {
        namespacesRequired: ["myfitsociety", "mobile-landing"],
        initialLanguage: currentLanguage,
        cfCountry: actualCFCountry,
        page_source: 'premium',
        landingPageContent,
        pricingContent,
        additionalProps: {
            page_source: 'premium',
            promo_price: false,
        },
    };
};

export default withTranslation(["myfitsociety", "mobile-landing"])(NewLandingPage);